import { ABTestImpressionAnalytic, AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../../../shared/scripts/analytics/Analytics.ts';
import { showDisableAdblockDialog } from '../../../shared/scripts/ui_popup/disable_adblock_dialog/showDisableAdblockDialog.ts';
export class UIAdBlockController {
    static shouldShowSoftBlockPopup(userState, isAdblockActive) {
        if (userState === null || userState === void 0 ? void 0 : userState.items.hasMembership()) return false;
        if (isAdblockActive == false) return false;
        var _userState_karmaCompletedGameCount;
        if (((_userState_karmaCompletedGameCount = userState === null || userState === void 0 ? void 0 : userState.karmaCompletedGameCount) !== null && _userState_karmaCompletedGameCount !== void 0 ? _userState_karmaCompletedGameCount : 0) <= this.getSoftBlockGameLimitNumber()) return false;
        return true;
    }
    static getSoftBlockGameLimitNumber() {
        return 10;
    }
    static showDisableAdblockPopup(continuationAction, variant) {
        const eventData = {
            type: AnalyticEventType.ABTestImpressionAnalytics,
            category: AnalyticEventCategory.ABTestImpressionAnalytics,
            floatValue: ABTestImpressionAnalytic.AdblockPopupHumorous
        };
        void CA.sendAnalyticEvent(eventData);
        showDisableAdblockDialog({
            continuationAction: continuationAction,
            variant: variant
        });
    }
}
